import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import adjustmentService from '@/services/adjustmentService';
import Input from '@/components/common/Input';
import Button from '@/components/common/Button';
import MainLayout from '@/components/layout/MainLayout';

export default function AdjustmentFactorForm() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ anio: new Date().getFullYear(), mes: new Date().getMonth() + 1, valor: 0 });
  const [saving, setSaving] = useState(false);

  const onSubmit = async () => {
    setSaving(true);
    try {
      await adjustmentService.createAdjustmentFactor(form);
      navigate('/adjustments');
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainLayout>
      <div className="p-4 max-w-md">
        <h1 className="text-xl font-semibold mb-4">Definir Factor</h1>
        <p className="text-sm text-gray-600 mb-4">
          Selecciona el mes y año de vencimiento de los contratos. Este factor se usará para calcular las 12 mensualidades de su prórroga.
        </p>
        <div className="space-y-3">
          <Input label="Año" type="number" value={form.anio} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, anio: Number(e.target.value) })} />
          <Input label="Mes" type="number" value={form.mes} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, mes: Number(e.target.value) })} />
          <Input label="Valor (0.048 = 4.8%)" type="number" step="0.0001" value={form.valor} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, valor: Number(e.target.value) })} />
          <Button onClick={onSubmit} disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</Button>
        </div>
      </div>
    </MainLayout>
  );
}



